import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { FaTruck, FaShieldAlt, FaClock, FaEuroSign } from 'react-icons/fa';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-overlay"></div>
      
      <div className="container">
        <div className="hero-content">
          <h1>
            Votre partenaire de confiance<br />
            <span style={{ color: 'var(--blue-light)' }}>pour vos déménagements et transports</span>
          </h1>
          
          <p>
            Plus de 15 ans d'expertise à votre service. Des professionnels qualifiés 
            pour un déménagement en toute sérénité.
          </p>

          <div className="hero-buttons">
            <ScrollLink 
              to="contact" 
              smooth={true} 
              duration={500}
              className="btn-primary"
            >
              Demander un devis
            </ScrollLink>
            
            <ScrollLink 
              to="services" 
              smooth={true} 
              duration={500}
              className="btn-outline"
            >
              Nos services
            </ScrollLink>
          </div>

          <div className="hero-features">
            <div className="feature">
              <FaShieldAlt className="feature-icon" style={{ color: 'var(--blue-light)' }} />
              <span>100% sécurisé</span>
            </div>
            <div className="feature">
              <FaClock className="feature-icon" style={{ color: 'var(--blue-light)' }} />
              <span>Intervention rapide</span>
            </div>
            <div className="feature">
              <FaEuroSign className="feature-icon" style={{ color: 'var(--blue-light)' }} />
              <span>Prix compétitifs</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;